import { ModalButton } from 'baseui/modal'
import { ArrowLeft } from 'baseui/icon'

const BackToSearchButton = ({ onClick, text }) => {
  return (
    <ModalButton startEnhancer={() => <ArrowLeft size={24} />} onClick={onClick}>
      {text}
    </ModalButton>
  )
}

export default BackToSearchButton
